import React from "react";
import { InputNumber, Select } from "antd";

import { TextField } from "misc/fields";

export const CDDA_COMPONENTS = {
    OVERVIEW: "overview",
    DRIVERS_LOG: "driversLog",
    DEFECT_TICKETS: "defectTickets"
};

// Parameters with empty components array are shown for all components.
const CDDA_FLEET_PARAMETERS = [
    {
        name: "cddaChargingSocStart",
        label: "t_cdda_charging_soc_start",
        render: () => <InputNumber style={{ width: 300 }} min={0} max={100} />,
        description: "t_cdda_soc_start_description",
        group: "t_cdda_definition_charging",
        required: true,
        initialValue: 90,
        components: [CDDA_COMPONENTS.OVERVIEW]
    },
    {
        name: "cddaChargingSocRise",
        label: "t_cdda_charging_soc_rise",
        render: () => <InputNumber style={{ width: 300 }} min={0} max={100} />,
        description: "t_cdda_soc_rise_description",
        group: "t_cdda_definition_charging",
        required: true,
        initialValue: 20,
        components: [CDDA_COMPONENTS.OVERVIEW]
    },
    {
        name: "cddaDrivingDistance",
        label: "t_cdda_driving_distance",
        render: () => <InputNumber style={{ width: 300 }} min={0} />,
        description: "t_cdda_driving_distance_description",
        group: "t_cdda_definition_driving",
        required: true,
        initialValue: 10,
        components: [CDDA_COMPONENTS.OVERVIEW]
    },
    {
        name: "cddaDeliveryDistance",
        label: "t_cdda_delivery_distance",
        render: () => <InputNumber style={{ width: 300 }} min={0} />,
        description: "t_cdda_delivery_distance_description",
        group: "t_cdda_definition_delivery",
        required: true,
        initialValue: 10,
        components: [CDDA_COMPONENTS.OVERVIEW]
    },
    {
        name: "cddaDeliveryStops",
        label: "t_cdda_delivery_stops",
        render: () => <InputNumber style={{ width: 300 }} min={0} />,
        description: "t_cdda_delivery_stops_description",
        definition: "t_cdda_delivery_stops_definition",
        group: "t_cdda_definition_delivery",
        required: true,
        initialValue: 10,
        components: [CDDA_COMPONENTS.OVERVIEW]
    },
    {
        name: "cddaDeliveryDriversLogEntry",
        label: "t_cdda_delivery_drivers_log_entry",
        render: () => (
            <Select style={{ width: 300 }}>
                <Select.Option value={true}>
                    <TextField value="t_yes" />
                </Select.Option>
                <Select.Option value={false}>
                    <TextField value="t_no" />
                </Select.Option>
            </Select>
        ),
        description: "t_cdda_delivery_drivers_log_entry_description",
        group: "t_cdda_definition_delivery",
        required: true,
        initialValue: false,
        components: [CDDA_COMPONENTS.OVERVIEW]
    }
];

export const getFleetParameters = (componentContext = null) => {
    if (!componentContext) {
        return [];
    }

    return CDDA_FLEET_PARAMETERS.filter(param => param.components.length === 0 || param.components.includes(componentContext));
};

export default CDDA_FLEET_PARAMETERS;
